export enum Source {
    Twitter = 0,
    Pixiv = 1,
    DeviantArt = 2,
    ArtStation = 3,
    Weibo = 4,
    Other = 5,
}
